import {CreateInstance} from './config'
const paymentAPI = CreateInstance('payment_history')
export default paymentAPI
